import { createReducer, on } from '@ngrx/store';
import { setAutonomyAction } from './autonomy.actions';




export const initialState = "-";

export const autonomyReducer = createReducer(
  initialState,
  on(setAutonomyAction, (state, { Autonomy }) => Autonomy)
);
